<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AnketYanitlar from "./AnketYanitlar.vue";
import AnketYanitlarGrid from "./AnketYanitlarGrid.vue";
import AnketYanitlarOran from "./AnketYanitlarOran.vue";
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Anketler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    AnketYanitlar,
    AnketYanitlarGrid,
    AnketYanitlarOran,
  },
  data() {
    return {
      title: this.$t("AnktDetay.Title"),
      items: [
        {
          text: this.$t("AnktDetay.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("AnktDetay.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("AnktDetay.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },

      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      AnketData: "",
      AnktAnketId: this.$route.params.AnktAnketId,
    };
  },

  methods: {
    Get() {
      var TumAnketlerKontrol = false;
      let YetkiSorgu = this.UserRolles.filter(
        (item) =>
          item.includes("AnketTumAnketler") || item.includes("SuperAdmin")
      );
      if (YetkiSorgu.length != 0) TumAnketlerKontrol = true;

      var BirimAnketlerKontrol = false;
      YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("AnketBirimAnketler")
      );
      if (YetkiSorgu.length != 0) BirimAnketlerKontrol = true;

      if (!TumAnketlerKontrol) {
        var Filter = "&Yetkilipersonelid=" + this.TokenUserId;
        Filter += "&Id=" + this.AnktAnketId;

        if (BirimAnketlerKontrol) {
          Filter += "&Birimanketlerinigorme=true";
        }

        this.ActionsFilterGet({
          Service: "AnktAnket",
          Page: this.PageToplu,
          Filter: Filter,
        }).then((res) => {
          if (res.Data.length == 0) {
            window.location = "/";
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <b-tabs content-class="p-3 text-muted">
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="far fa-user"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">
                            {{ $t("AnktDetay.Page.Yanitlar") }}
                          </span>
                        </template>
                        <AnketYanitlar :Data="AnketData" />
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="far fa-envelope"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">
                            {{ $t("AnktDetay.Page.YanitlarGrid") }}
                          </span>
                        </template>
                        <AnketYanitlarGrid />
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="far fa-envelope"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">
                            {{ $t("AnktDetay.Page.YanitlarOran") }}
                          </span>
                        </template>
                        <AnketYanitlarOran />
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
